// Module
export { PipesModule } from './pipes.module';

// Pipes
export * from './pipes';